<template>
  <section>
    <h3>404 Not Found</h3>
  </section>
</template>

<script>
export default {}
</script>
